import { render, staticRenderFns } from "./Inquiry-List.vue?vue&type=template&id=78f12db4&scoped=true&"
import script from "./Inquiry-List.vue?vue&type=script&lang=js&"
export * from "./Inquiry-List.vue?vue&type=script&lang=js&"
import style0 from "./Inquiry-List.vue?vue&type=style&index=0&id=78f12db4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f12db4",
  null
  
)

export default component.exports